import DoneIcon from '@mui/icons-material/Done';
import SyncIcon from '@mui/icons-material/Sync';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Box from '@mui/material/Box';

import { normalizeSx } from '@/utils/normalizeSx';

import type { SxProps, Theme } from '@mui/material/styles';

const containerBaseSx: SxProps<Theme> = theme => ({
  gap: 0.5,
  display: 'flex',
  alignItems: 'center',
  fontSize: theme.typography.pxToRem(14),
  height: 30,
  justifyContent: 'center'
});

const iconSx: SxProps<Theme> = theme => ({ fontSize: theme.typography.pxToRem(16) });

const STATUS_CONFIG = {
  ongoing: {
    label: 'Processing',
    icon: SyncIcon,
    sx: {} as SxProps<Theme>
  },
  finished: {
    label: 'Completed',
    icon: DoneIcon,
    sx: { color: 'success.main' } as SxProps<Theme>
  },
  failed: {
    label: 'Failed',
    icon: WarningAmberIcon,
    sx: { color: 'error.main' } as SxProps<Theme>
  }
};

export const Status = ({ status }: { status: keyof typeof STATUS_CONFIG }) => {
  const { label, icon: Icon, sx } = STATUS_CONFIG[status];

  return (
    <Box sx={[containerBaseSx, ...normalizeSx(sx)]}>
      <Icon sx={iconSx} />
      {label}
    </Box>
  );
};
